module.exports = __webpack_public_path__ + "static/media/ball_5_6.c07126e5.mp3";